module.exports = __webpack_public_path__ + "img/pattern.0be6a74b.svg";